<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleComprador"
             color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             link to="/cadastro-compra">
        <v-icon left>mdi-plus</v-icon>
        Compras
      </v-btn>
      <v-spacer/>
      <v-btn v-if="hasFilters"
             small
             text
             class="normal-btn-text rounded-tag-small mt-1"
             @click="clearFilters">
        Limpar filtros
        <v-icon right small color="error">mdi-close</v-icon>
      </v-btn>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-listagem-compra-filtro ref="filtros" @change="emitChange"/>
      <px-search-text class="rounded-tag-small"
                      v-model="searchText"
                      style="max-width: 400px"
                      :label="labelSearchBox"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions"
                    :on-select-item="emitChange"
                    v-model="selectedStatus"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EntidadeCamposPersonalizadosService from '@/modules/campos-personalizados/entidade-campos-personalizados-service';
import ListagemCompraFiltro from './ListagemCompraFiltro.vue';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    ...mapGetters('entidade', ['hasIntegracaoAtiva', 'idEntidade']),
    ...mapGetters('listagemCompra', ['hasCustomFilters']),
    selectedStatus: {
      get() {
        return this.$store.getters['listagemCompra/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemCompra/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemCompra/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemCompra/searchText', searchText);
      },
    },
    camposPersonalizados: {
      get() {
        return this.$store.getters['listagemCompra/camposPersonalizados'];
      },
      set(camposPersonalizados) {
        this.$store.dispatch('listagemCompra/camposPersonalizados', camposPersonalizados);
      },
    },
    labelSearchBox() {
      return this.hasIntegracaoAtiva ? 'Busque por código ou número da OC' : 'Busque por código';
    },
    hasFilters() {
      return this.hasCustomFilters || this.searchText;
    },
    statusOptions() {
      return [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        ...(this.hasIntegracaoAtiva
          ? [
            {
              id: 'PENDENTE_INTEGRACAO',
              description: 'Pendentes de integração',
              value: null,
            },
          ]
          : []),
        {
          id: 'RASCUNHO',
          description: 'Rascunhos',
          value: ['RASCUNHO'],
        },
        {
          id: 'APROVADAS',
          description: 'Aprovadas',
          value: ['APROVADA'],
        },
        {
          id: 'ABERTAS',
          description: 'Abertas',
          value: ['PENDENTE_COMPRADOR', 'PENDENTE_FORNECEDOR'],
        },
        {
          id: 'ELABORACAO',
          description: 'Em elaboração',
          value: ['ELABORACAO'],
        },
        {
          id: 'CANCELADAS',
          description: 'Canceladas',
          value: ['CANCELADA'],
        },
        {
          id: 'RECUSADAS',
          description: 'Recusadas',
          value: ['RECUSADA'],
        },
      ];
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
    clearFilters() {
      this.searchText = null;
      this.$refs.filtros.clearFilters();
    },
    getCamposPersonalizados() {
      EntidadeCamposPersonalizadosService.getCamposPersonalizadosCompraById(this.idEntidade)
        .then((campos) => {
          this.camposPersonalizados = campos;
        });
    },
  },
  created() {
    this.getCamposPersonalizados();
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
  components: {
    pxListagemCompraFiltro: ListagemCompraFiltro,
  },
};
</script>
